import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';
import { ThemeProps } from 'types/styled';

import pluralize from 'helpers/pluralize';
import useMedia from 'hooks/useMedia';

import Box from 'components/elements/Box';
import {
  Caret,
  CaretSpan,
} from 'components/base/TopicFiltersDropdown/shared/styles';
import Span from 'components/elements/span';

import { ReactComponent as ClearButton } from 'icons/icon-clear-button.svg';

import colors from 'styles/themes/colors';

const ButtonBox = styled(Box)<ThemeProps<'div'>>`
  padding: 0.6875rem 2rem;
  background: ${({ theme }): string => theme.LightGrey};
  color: ${({ theme }): string => theme.NightBlue};
  border-radius: 5px;
  font-weight: 600;
  font-size: 18px;

  ${Caret} {
    width: 14px;
    height: 11px;
  }
`;

export const getButtonWithDefaultLabel = (
  clearFilter?: any,
  defaultLabel?: string
): ReactNode => {
  const LabeledButton: React.FC<any> = (props: any) => {
    return (
      <DropdownButton
        {...props}
        defaultLabel={defaultLabel}
        dropdownType="Playlist Territory"
        clearFilter={clearFilter}
      />
    );
  };
  return LabeledButton;
};

interface IButtonProps {
  selectedItem: any;
  selectedItems?: any;
  isOpen?: boolean;
  disabled?: boolean;
  defaultLabel?: string;
  isDisplayedWithFlag?: boolean;
  dropdownType: 'Region' | 'Territory' | 'Timeframe';
  clearFilter?: () => void;
  withoutArrow?: boolean;
}

const DropdownButton: React.FC<IButtonProps> = (props) => {
  const {
    selectedItem,
    selectedItems,
    isOpen,
    disabled,
    defaultLabel,
    dropdownType,
    clearFilter,
    withoutArrow,
  } = props;

  const isSmallScreen: boolean = useMedia('(max-width: 47em)');

  const hasSelectedValue = selectedItem || selectedItems?.length > 0;
  const boxColor = disabled
    ? colors.DisabledGrey
    : hasSelectedValue && !withoutArrow
    ? colors.White
    : colors.NightBlue;

  return (
    <ButtonBox
      py={1}
      px={2}
      display="flex"
      alignItems="center"
      justifyContent="flex-start"
      alignContent="stretch"
      color={isSmallScreen ? colors.NightBlue : boxColor}
      selected={hasSelectedValue && !withoutArrow}
    >
      {selectedItems?.length > 1 ? (
        <Span
          alignSelf="auto"
          marginRight="8px"
          fontWeight={600}
          style={{ whiteSpace: 'nowrap' }}
        >
          {`${pluralize(dropdownType, 2)} (${selectedItems.length})`}
        </Span>
      ) : (
        <Span alignSelf="auto" marginRight="8px" fontWeight={600}>
          {selectedItem
            ? selectedItem.label || selectedItem.displayName
            : defaultLabel}
        </Span>
      )}
      {!withoutArrow && (
        <CaretSpan>
          <Caret isPointingUp={isOpen} isSmall={!isSmallScreen} />
        </CaretSpan>
      )}

      {!!hasSelectedValue && clearFilter && !withoutArrow && !isSmallScreen && (
        <Span
          marginLeft="10px"
          alignSelf="auto"
          display="flex"
          onClick={(e): void => {
            e.preventDefault();
            e.stopPropagation();
            clearFilter();
          }}
        >
          <ClearButton />
        </Span>
      )}
    </ButtonBox>
  );
};

export default DropdownButton;
